import { coreInitiativesTasksGetAsyncSlice } from '../get';
import { CoreInitiativesTasksLinkName } from './name';
import { postInitiativeTaskLink } from '@api';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesTasksLinkPostAsyncSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.INITIATIVE_SCOPE_LINKED_TO_TASK, (action) => ({
				bulk: action.data.all,
				scopeCount: action.data.sonarObjectIds?.length ?? action.data.initiativeScopeIds?.length
			})),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			({ initiativeId }) =>
				coreInitiativesTasksGetAsyncSlice.asyncActionCreators.requestGetCoreInitiativesTasks({ initiativeId })
		]
	},
	name: CoreInitiativesTasksLinkName,
	receive: false,
	request: true,
	requestHandler: postInitiativeTaskLink
});
